import { render, staticRenderFns } from "./PopUpAddFromCatalog.vue?vue&type=template&id=618680e0&scoped=true&"
import script from "./PopUpAddFromCatalog.vue?vue&type=script&lang=js&"
export * from "./PopUpAddFromCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618680e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('618680e0')) {
      api.createRecord('618680e0', component.options)
    } else {
      api.reload('618680e0', component.options)
    }
    module.hot.accept("./PopUpAddFromCatalog.vue?vue&type=template&id=618680e0&scoped=true&", function () {
      api.rerender('618680e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/vistas/modals/PopUpAddFromCatalog.vue"
export default component.exports